import moment from "moment";

export const getConfigSales = (tab) => {
    return tab === "variant"
        ? [...configSegmen,
            {name: "kodeVarian", label: "Kode Varian"},
            {name: "namaVarian", label: "Nama Varian", options: {sort: false}},
            ...configSalesVariant]
        : tab === "type"
            ? [...configSegmen,
                {name: "namaTipe", label: "Nama Tipe"},
                ...configSales]
            : tab === "series"
                ? [...configSegmen,
                    {name: "namaSeries", label: "Nama Series"},
                    ...configSales]
                : tab === "subSegment"
                    ? [...configSegmen,
                        {name: "namaSubSegmen", label: "Nama Sub Segmen"},
                        ...configSales]
                    : [];
};

export const getConfigYearToDate = (tab, year) => {
    console.log(year,'year')
    return tab === "variant"
        ? [...configSegmen,
            {name: "kodeVarian", label: "Kode Varian"},
            {name: "namaVarian", label: "Nama Varian", options: {sort: false}},
            ...configYearToDate(year)]
        : tab === "type"
            ? [...configSegmen,
                {name: "namaTipe", label: "Nama Tipe"},
                ...configYearToDate(year)]
            : tab === "series"
                ? [...configSegmen,
                    {name: "namaSeries", label: "Nama Series"},
                    ...configYearToDate(year)]
                : tab === "subSegment"
                    ? [...configSegmen,
                        {name: "namaSubSegment", label: "Nama Sub Segmen"},
                        ...configYearToDate(year)]
                    : [];
};

const configSegmen = [
    {name: "segmen", label: "SEGMEN"},
];

const configSalesVariant = [
    {name: "totalLastMonth", label: "Total\nLast Month", options: {sort: false}},
    {name: "totalThisMonth", label: "Total\nThis Month"},
    {name: "totalGrowth", label: "Growth", options: {customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
    {name: "projection", label: "Proyeksi", options: {sort: false}},
    {name: "cashLastMonth", label: "Cash\nLast Month", options: {sort: false}},
    {name: "cashThisMonth", label: "Cash\nThis Month"},
    {name: "cashGrowth", label: "Growth", options: { customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
    {name: "creditLastMonth", label: "Credit\nLast Month", options: {sort: false}},
    {name: "creditThisMonth", label: "Credit\nThis Month"},
    {name: "creditGrowth", label: "Growth", options: {customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
];

const configSales = [
    {name: "totalLastMonth", label: "Total\nLast Month", options: {sort: false}},
    {name: "totalThisMonth", label: "Total\nThis Month", options: {}},
    {name: "totalGrowth", label: "Growth", options: { customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
    {name: "cashLastMonth", label: "Cash\nLast Month", options: {sort: false}},
    {name: "cashThisMonth", label: "Cash\nThis Month", options: {}},
    {name: "cashGrowth", label: "Growth", options: {customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
    {name: "creditLastMonth", label: "Credit\nLast Month", options: {sort: false}},
    {name: "creditThisMonth", label: "Credit\nThis Month", options: {}},
    {name: "creditGrowth", label: "Growth", options: {customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
];

const configYearToDate  = (year) => [
    {name: "jan", label: "JAN", options: {sort: false}},
    {name: "feb", label: "FEB", options: {sort: false}},
    {name: "mar", label: "MAR", options: {sort: false}},
    {name: "apr", label: "APR", options: {sort: false}},
    {name: "may", label: "MAY", options: {sort: false}},
    {name: "jun", label: "JUN", options: {sort: false}},
    {name: "jul", label: "JUL", options: {sort: false}},
    {name: "aug", label: "AUG", options: {sort: false}},
    {name: "sep", label: "SEP", options: {sort: false}},
    {name: "oct", label: "OCT", options: {sort: false}},
    {name: "nov", label: "NOV", options: {sort: false}},
    {name: "dec", label: "DEC", options: {sort: false}},
    {name: "yearToDate", label: year || moment().format("YYYY"), options: {sort: false}},
];